import { createSlice } from "@reduxjs/toolkit";

import { endOfMonth, format, startOfMonth } from "date-fns";
import { DATE_FORMAT } from "../../consts/AppContants";
import { getInputDate } from "../../utils/utils";
import { LOCALES } from "../../components/LocaleSwitch";

import secureLocalStorage from "react-secure-storage";
import { AUTH_LOCAL_VARIABLES } from "./authSlice";

function getLocaleFromLocalStorage() {
  const locale = localStorage.getItem("i18nextLng") || null;

  if (locale) {
    const lc = LOCALES.find((item) => item.locale === locale) || null;
    return lc;
  }

  return LOCALES[0];
}

const INITIAL_STATE = {
  locale: getLocaleFromLocalStorage() || LOCALES[0],
  inputDate: {
    startDate: format(startOfMonth(new Date()), DATE_FORMAT),
    endDate: format(endOfMonth(new Date()), DATE_FORMAT),
    date: getInputDate({
      startDate: format(startOfMonth(new Date()), DATE_FORMAT),
      endDate: format(endOfMonth(new Date()), DATE_FORMAT),
    }),
  },
  currentProgram: null || sessionStorage.getItem("currentProgram"),
  countryList: null || JSON.parse(sessionStorage.getItem("countryList")),
  regions: secureLocalStorage.getItem(AUTH_LOCAL_VARIABLES.REGIONS) || [],
  activeRegion: secureLocalStorage.getItem(AUTH_LOCAL_VARIABLES.REGION) || null,
  featureFlags: {},
};

const globalSlice = createSlice({
  name: "global",
  initialState: INITIAL_STATE,
  reducers: {
    resetDateRange: (state) => {
      state.inputDate = INITIAL_STATE.inputDate;
    },
    setInputDate: (state, { payload }) => {
      state.inputDate = payload;
    },
    populateSelectedDate: (state, { payload }) => {
      state.inputDate = payload;
    },
    setCountryList: (state, { payload }) => {
      state.countryList = payload;
      sessionStorage.setItem("countryList", JSON.stringify(payload));
    },
    setCurrentProgram: (state, { payload }) => {
      state.currentProgram = payload;
      sessionStorage.setItem("currentProgram", payload);
    },
    setLocale: (state, { payload }) => {
      state.locale = payload;
    },
    setRegions: (state, { payload }) => {
      state.regions = payload;
      secureLocalStorage.setItem(AUTH_LOCAL_VARIABLES.REGIONS, payload);
    },
    setActiveRegion: (state, { payload }) => {
      state.activeRegion = payload;
      secureLocalStorage.setItem(AUTH_LOCAL_VARIABLES.REGION, payload);
    },
    setFeatureFlags: (state, { payload }) => {
      state.featureFlags = payload;
    },
  },
});

export const globalReducer = globalSlice.reducer;

export const {
  setCountryList,
  setCurrentProgram,
  resetDateRange,
  setInputDate,
  setLocale,
  setRegions,
  setActiveRegion,
  setFeatureFlags,
} = globalSlice.actions;

export default globalSlice;
